import {PLAN_NAME_PARTY_PASS, PLAN_NAME_PRO} from '~/common/fabric/routes/EventReview/constants';

export const selectIsPremium = ({details, ecard}) => details?.isPremium ?? !!ecard; // eCards are always premium
export const selectIsProOrPartyPass = ({user}) =>
  user.subscriptionPlanName === PLAN_NAME_PRO || user.subscriptionPlanName === PLAN_NAME_PARTY_PASS;
export const selectEnvelopes = ({fabricTemplate}) => fabricTemplate.allEnvelopes;
export const selectLiners = ({fabricTemplate}) => fabricTemplate.allLiners;
export const selectBackgrounds = ({fabricTemplate}) => fabricTemplate.allBackgrounds;
export const selectStamps = ({fabricTemplate}) => fabricTemplate.allStamps;
export const selectStickers = ({fabricTemplate}) => fabricTemplate.allStickers;
export const selectSnapshot = ({fabricTemplate}) => fabricTemplate.snapshot;
export const selectTemplateName = ({fabricTemplate}) => fabricTemplate.templateName;
